import { Crown, Sparkles, Rocket, Star } from "lucide-react";

// Plan catalog — order matters (free → starter → pro → pro_plus).
// Keep this single source of truth so backend pricing changes only require updating one place.
export const buildTiers = (t) => [
  {
    id: "free", package_id: null, name: t("billing.tiers.free.name"), price: 0,
    tagline: t("billing.tiers.free.tagline"), Icon: Sparkles, accent: "blue",
    features: [true, true, true, true, false, false, false].map((ok, i) => ({
      ok, text: t(`billing.tiers.free.f${i + 1}`),
    })),
  },
  {
    id: "starter", package_id: "starter_monthly", name: t("billing.tiers.starter.name"), price: 19,
    tagline: t("billing.tiers.starter.tagline"), Icon: Rocket, accent: "cyan",
    features: [true, true, true, true, true, false, false].map((ok, i) => ({
      ok, text: t(`billing.tiers.starter.f${i + 1}`),
    })),
  },
  {
    id: "pro", package_id: "pro_monthly", name: t("billing.tiers.pro.name"), price: 49,
    tagline: t("billing.tiers.pro.tagline"), Icon: Star, accent: "amber", popular: true,
    features: [true, true, true, true, true, true, false].map((ok, i) => ({
      ok, text: t(`billing.tiers.pro.f${i + 1}`),
    })),
  },
  {
    id: "pro_plus", package_id: "pro_plus_monthly", name: t("billing.tiers.proPlus.name"), price: 99,
    tagline: t("billing.tiers.proPlus.tagline"), Icon: Crown, accent: "violet",
    features: [true, true, true, true, true, true, true].map((ok, i) => ({
      ok, text: t(`billing.tiers.proPlus.f${i + 1}`),
    })),
  },
];

export const ACCENT_CLASSES = {
  blue:   { border: "border-blue-500/60 ring-blue-500/30",     text: "text-blue-300",   bg: "bg-blue-500/20",   btn: "bg-blue-600 hover:bg-blue-500" },
  cyan:   { border: "border-cyan-500/60 ring-cyan-500/30",     text: "text-cyan-300",   bg: "bg-cyan-500/20",   btn: "bg-cyan-600 hover:bg-cyan-500" },
  amber:  { border: "border-amber-500/60 ring-amber-500/30",   text: "text-amber-300",  bg: "bg-amber-500/20",  btn: "bg-amber-600 hover:bg-amber-500" },
  violet: { border: "border-violet-500/60 ring-violet-500/30", text: "text-violet-300", bg: "bg-violet-500/20", btn: "bg-violet-600 hover:bg-violet-500" },
};
